import { useQuery } from "@tanstack/react-query"

import { getAffiliateById, getAffiliatePreviewById } from "@/api"

export const useAffiliateDetails = (id: string | undefined, options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: ["affiliate_detail_" + id],
    enabled: (options?.enabled ?? true) && !!id,
    queryFn: () => getAffiliateById(id as string)
  })
}

export const useAffiliatePreviewDetails = (id: string | undefined, accessToken?: string) => {
  return useQuery({
    queryKey: ["affiliate_detail_" + id + accessToken],
    enabled: !!id && !!accessToken,
    queryFn: () => getAffiliatePreviewById(id as string, accessToken)
  })
}
